import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { NavBar, Footer, ProtectedRoute } from './shared/components';
import CollegeAlgebraApp from './pages/CollegeAlgebra/CollegeAlgebraApp';
import './shared/App.css';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Quizzes from './pages/Quizzes';
import Flashcards from './pages/Flashcards';
import Vocabulary from './pages/Vocabulary';
import Exams from './pages/Exams';
import Progress from './pages/Progress';
import AISettings from './pages/Settings';
import StudyGuide from './pages/StudyGuide';
import ReadingWriting from './pages/StudyGuide/ReadingWriting';
import MathGuide from './pages/StudyGuide/MathGuide';
import GrammarReference from './pages/StudyGuide/GrammarReference';
import TestStrategies from './pages/StudyGuide/TestStrategies';
import CraftStructureReference from './pages/StudyGuide/CraftStructureReference';
import InformationIdeasReference from './pages/StudyGuide/InformationIdeasReference';
import ExpressionIdeasReference from './pages/StudyGuide/ExpressionIdeasReference';
import AlgebraReference from './pages/StudyGuide/AlgebraReference';
import AdvancedMathReference from './pages/StudyGuide/AdvancedMathReference';
import PsdaReference from './pages/StudyGuide/PsdaReference';
import GeometryReference from './pages/StudyGuide/GeometryReference';

export default function App() {
  const location = useLocation();

  // College Algebra is a separate app -- its own title bar, nav, and footer
  // (see CollegeAlgebraApp.js) -- not another route inside the SAT Prep
  // layout below, so it's branched here before the SAT <Routes> even runs.
  if (location.pathname.startsWith('/college-algebra')) {
    return <CollegeAlgebraApp />;
  }

  return (
    <div className="app-layout">
      <NavBar />
      <main className="app-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="/quizzes" element={<ProtectedRoute element={<Quizzes />} />} />
          <Route path="/flashcards" element={<ProtectedRoute element={<Flashcards />} />} />
          <Route path="/vocabulary" element={<ProtectedRoute element={<Vocabulary />} />} />
          <Route path="/exams" element={<ProtectedRoute element={<Exams />} />} />
          <Route path="/progress" element={<ProtectedRoute element={<Progress />} />} />
          <Route path="/settings/ai" element={<ProtectedRoute element={<AISettings />} />} />
          <Route path="/study-guide" element={<ProtectedRoute element={<StudyGuide />} />} />
          <Route path="/study-guide/reading-and-writing" element={<ProtectedRoute element={<ReadingWriting />} />} />
          <Route path="/study-guide/math" element={<ProtectedRoute element={<MathGuide />} />} />
          <Route path="/study-guide/grammar-reference" element={<ProtectedRoute element={<GrammarReference />} />} />
          <Route path="/study-guide/test-strategies" element={<ProtectedRoute element={<TestStrategies />} />} />
          <Route path="/study-guide/craft-and-structure-reference" element={<ProtectedRoute element={<CraftStructureReference />} />} />
          <Route path="/study-guide/information-and-ideas-reference" element={<ProtectedRoute element={<InformationIdeasReference />} />} />
          <Route path="/study-guide/expression-of-ideas-reference" element={<ProtectedRoute element={<ExpressionIdeasReference />} />} />
          <Route path="/study-guide/algebra-reference" element={<ProtectedRoute element={<AlgebraReference />} />} />
          <Route path="/study-guide/advanced-math-reference" element={<ProtectedRoute element={<AdvancedMathReference />} />} />
          <Route path="/study-guide/problem-solving-data-analysis-reference" element={<ProtectedRoute element={<PsdaReference />} />} />
          <Route path="/study-guide/geometry-trigonometry-reference" element={<ProtectedRoute element={<GeometryReference />} />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
